import { unassociatedIncomePages } from './unassociatedIncomePages';

export default {
  title: 'Recurring income',
  pages: unassociatedIncomePages,
};
